import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const Lectures = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="Lectures" />
                    <HerosectionsAll ScreenName="Lectures" ScreenSearch="LearningAndDevelopment" />

                    <div className="row col-lg-9 mx-auto p-2 p-lg-5 my-5">
                        <div className="col-12 p-lg-5 faint p-4" style={{textAlign: 'justify'}}>
                            <h5 className="fw-bold gray_color pb-3">Lectures</h5>
                            <p> It is traditional and more informative CPD tool. <br />We design our lectures after conducting Training Need Analysis (TNA) of a person/organization. <br />This helps people thrive in their respective fields and attain their goals through need based learning. </p>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
